import React from 'react'
import agent from '../agent'
import TokenList from './widgets/TokenList';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import {
    TOKEN_LIST_PAGE_LOADED,
    TOKEN_LIST_PAGE_UNLOADED,
    TOKEN_CREATE,
} from '../constants/actionTypes'
import role from '../util/role'
const mapStateToProps = state => ({
    ...state.token,
    currentUser: state.common.currentUser,
    appName: state.common.appName,
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) => {
        dispatch({ type: TOKEN_LIST_PAGE_LOADED, payload })
    },
    onUnload: () =>
        dispatch({ type: TOKEN_LIST_PAGE_UNLOADED }),
});

class Tokens extends React.Component {
    constructor() {
        super();
    }
    componentWillMount() {
        const payload = agent.Tokens.getTokens()
        this.props.onLoad(payload);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        return (
            <div class='pane'>
                <Link className="buttonTopText" to='/tokens/admins'>Token Owners</Link>
                {role.can(this.props.currentUser.role, TOKEN_CREATE) ?
                    <Link className="buttonTopText" to='/tokens/fees'>Manage Creation Fee</Link>
                    : null}
                <h1>Tokens</h1>
                <TokenList data={this.props.tokens} loading={this.props.loading} />
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tokens);



// WEBPACK FOOTER //
// ./src/components/Tokens.js